function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "website",
  transform: "translate(-1 -4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11703",
  "data-name": "Path 11703",
  d: "M21.778,10.5A2.278,2.278,0,0,0,19.5,12.778V31a2.278,2.278,0,0,0,2.278,2.278h9.111A2.278,2.278,0,0,0,33.167,31V12.778A2.278,2.278,0,0,0,30.889,10.5Zm6.833,4.556H24.056V28.722h4.556Z",
  transform: "translate(9.333 3.111)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11704",
  "data-name": "Path 11704",
  d: "M9.778,10.5a2.278,2.278,0,1,0,0,4.556h9.111a2.278,2.278,0,1,0,0-4.556Z",
  transform: "translate(3.111 3.111)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11705",
  "data-name": "Path 11705",
  d: "M9.778,16.5a2.278,2.278,0,1,0,0,4.556h9.111a2.278,2.278,0,1,0,0-4.556Z",
  transform: "translate(3.111 6.222)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11706",
  "data-name": "Path 11706",
  d: "M7.5,24.778A2.278,2.278,0,0,1,9.778,22.5h9.111a2.278,2.278,0,0,1,0,4.556H9.778A2.278,2.278,0,0,1,7.5,24.778Z",
  transform: "translate(3.111 9.333)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11707",
  "data-name": "Path 11707",
  d: "M8.333,4.5A6.833,6.833,0,0,0,1.5,11.333V38.667A6.833,6.833,0,0,0,8.333,45.5H44.778a6.833,6.833,0,0,0,6.833-6.833V11.333A6.833,6.833,0,0,0,44.778,4.5ZM44.778,9.056H8.333a2.278,2.278,0,0,0-2.278,2.278V38.667a2.278,2.278,0,0,0,2.278,2.278H44.778a2.278,2.278,0,0,0,2.278-2.278V11.333A2.278,2.278,0,0,0,44.778,9.056Z",
  transform: "translate(0)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1,
  fillRule: "evenodd"
}));

var SvgWebsite = function SvgWebsite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51.111,
    height: 42,
    viewBox: "0 0 51.111 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWebsite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/website.221c9939.svg";
export { ForwardRef as ReactComponent };